/** CoStar.Api.ConsumerUserData.User.AccessLevel */
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["Unknown"] = 0] = "Unknown";
    AccessLevel[AccessLevel["Read"] = 10] = "Read";
    AccessLevel[AccessLevel["ReadWrite"] = 20] = "ReadWrite";
})(AccessLevel || (AccessLevel = {}));
/** CoStar.Api.ConsumerUserData.User.Status */
export var Status;
(function (Status) {
    Status[Status["Inactive"] = 0] = "Inactive";
    Status[Status["Active"] = 1] = "Active";
})(Status || (Status = {}));
/** CoStar.Api.ConsumerUserData.User.UserSearchType */
export var UserSearchType;
(function (UserSearchType) {
    UserSearchType[UserSearchType["Unknown"] = 0] = "Unknown";
    UserSearchType[UserSearchType["FirstName"] = 1] = "FirstName";
    UserSearchType[UserSearchType["LastName"] = 2] = "LastName";
    UserSearchType[UserSearchType["Email"] = 3] = "Email";
    UserSearchType[UserSearchType["UserKey"] = 4] = "UserKey";
    UserSearchType[UserSearchType["PropertyId"] = 5] = "PropertyId";
    UserSearchType[UserSearchType["PropertyName"] = 6] = "PropertyName";
    UserSearchType[UserSearchType["PropertyManagementCompanyName"] = 7] = "PropertyManagementCompanyName";
    UserSearchType[UserSearchType["PropertyManagementCompanyId"] = 8] = "PropertyManagementCompanyId";
    UserSearchType[UserSearchType["CompanyAndPropertyName"] = 9] = "CompanyAndPropertyName";
    UserSearchType[UserSearchType["ListingId"] = 10] = "ListingId";
    UserSearchType[UserSearchType["ListingSubscriptionId"] = 11] = "ListingSubscriptionId";
})(UserSearchType || (UserSearchType = {}));
import { UserSearchStatuses } from "../../../../CoStar/Api/AptsUser/ViewModels/index.js";
/** CoStar.Api.ConsumerUserData.User.UserSearchStatuses */
export { UserSearchStatuses };
